import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { useUserStore } from '@/store/userStore';
import { userService } from '../../services/userService';

export const useGetUserLocation = () => {
  const accessToken = useUserStore(state => state.accessToken);
  return useQuery({
    queryKey: [QUERY_KEYS.user.my_location],
    staleTime: Infinity,
    enabled: !!accessToken,
    queryFn: () =>
      userService.userLocation().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return {
            city: data.city,
            country: data.country_name,
            countryCode: data.country_code,
            postal: data.postal,
            state: data.state,
            ip: data.IPv4,
            lat: data.latitude,
            lon: data.longitude,
          };
        }
        return null;
      }),
  });
};
